import { useEffect, useRef, useState } from "react";

import { ReactComponent as AddIcon } from "../../assets/icons/add.svg";
import styles from "../../styles/components/MailsToolbar.module.css";

import ChoiceChip from "../../ui/selectors/ChoiceChip.jsx";
import SearchInput from "../../ui/inputs/SearchInput.jsx";
import Button from "../../ui/buttons/Button.jsx";
import MailsFindFrame from "./MailsFindFrame.jsx";

const MailsToolbar = ({
  onSearchChange,
  onFilterChange,
  onOpenReview,
  onNewMail,
  selectedFilter,
  mailComunicationState,
  filtersEnabled = true,
  appliedFilters,
  mailAccountOptions = [],
  onApplyFilters,
}) => {
  const [isFindFrameOpen, setIsFindFrameOpen] = useState(false);
  const searchAreaRef = useRef(null);

  const handleFilterChange = (value) => {
    onFilterChange?.(value);
    if (value === "op2") {
      onOpenReview?.();
    }
  };

  const openFindFrame = () => {
    if (filtersEnabled) setIsFindFrameOpen(true);
  };

  useEffect(() => {
    if (!filtersEnabled) setIsFindFrameOpen(false);
  }, [filtersEnabled]);

  const searchInputKey = mailComunicationState
    ? "mail-items"
    : selectedFilter === "op3"
      ? "error-mails"
      : "template-groups";

  return (
    <div className={styles.toolbar}>
      <div className={styles.searchBarParent}>
        <div className={styles.filters}>
          {/* La key remonta el input al cambiar de vista para que la búsqueda
              de grupos no quede escrita al entrar al detalle (y viceversa). */}
          <div
            ref={searchAreaRef}
            onClick={openFindFrame}
            onFocus={openFindFrame}
          >
            <SearchInput
              key={searchInputKey}
              onSearch={onSearchChange}
              width={241}
              height={40}
            />
          </div>

          {!mailComunicationState && (
            <div className={styles.filterGroup}>
              <ChoiceChip
                label="Todos los mails"
                selected={selectedFilter === "op1"}
                onClick={() => handleFilterChange("op1")}
                height={40}
                iconSize={0}
                fontWeight={500}
                padding="12px 16px"
                selectedColor="var(--text-cta-primary)"
                unselectedColor="var(--text-tertiary)"
                selectedBackground="var(--surface-accent-hover)"
                unselectedBackground="transparent"
              />

              <ChoiceChip
                label="Mail a revisar"
                selected={selectedFilter === "op2"}
                onClick={() => handleFilterChange("op2")}
                height={40}
                iconSize={0}
                fontWeight={500}
                padding="12px 16px"
                selectedColor="var(--text-cta-primary)"
                unselectedColor="var(--text-tertiary)"
                selectedBackground="var(--surface-accent-hover)"
                unselectedBackground="transparent"
              />

              <ChoiceChip
                label="Mails con errores"
                selected={selectedFilter === "op3"}
                onClick={() => handleFilterChange("op3")}
                height={40}
                iconSize={0}
                fontWeight={500}
                padding="12px 16px"
                selectedColor="var(--text-cta-primary)"
                unselectedColor="var(--text-tertiary)"
                selectedBackground="var(--surface-accent-hover)"
                unselectedBackground="transparent"
              />
            </div>
          )}
        </div>

        {filtersEnabled && isFindFrameOpen && (
          <MailsFindFrame
            appliedFilters={appliedFilters}
            mailAccountOptions={mailAccountOptions}
            onlyResponsible={
              (selectedFilter === "op2" || selectedFilter === "op3") &&
              !mailComunicationState
            }
            onApply={onApplyFilters}
            onClose={() => setIsFindFrameOpen(false)}
            anchorRef={searchAreaRef}
          />
        )}
      </div>

      <Button
        type="button"
        iconLeft={<AddIcon />}
        onClick={onNewMail}
        width={124}
        height={40}
        style={{
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 8,
          paddingRight: 16,
          background: "var(--surface-accent-hover)",
          color: "var(--text-cta-primary)",
          fontSize: 13,
          fontFamily: "DM Sans",
          fontWeight: 500,
          gap: 0,
        }}
      >
        Nuevo Mail
      </Button>
    </div>
  );
};

export default MailsToolbar;
